// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './condition-operator.properties';

const CONDITION_OPERATOR_TO_PERSISTENCE_KEY = {
  EQUAL: 'Equal',
  NOT_EQUAL: 'NotEqual',
  GREATER_THAN: 'GreaterThan',
  GREATER_EQUAL: 'GreaterEqual',
  LESS_THAN: 'LessThan',
  LESS_EQUAL: 'LessEqual'
} as const;

/** @see net/disy/cadenza/workbook/repository/attribute/ConditionOperator.java */
export type ConditionOperator = keyof typeof CONDITION_OPERATOR_TO_PERSISTENCE_KEY;

export const ConditionOperator = {
  values: Object.keys(CONDITION_OPERATOR_TO_PERSISTENCE_KEY) as readonly ConditionOperator[],
  toPersistenceKey: (value: ConditionOperator) => CONDITION_OPERATOR_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = ConditionOperator.values.find(key => CONDITION_OPERATOR_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No ConditionOperator for key: ${persistenceKey}`); }
    return value;
  },
  i18n: (value: ConditionOperator) => i18n(`<${value}>`),
} as const;

// </GENERATED-CODE>

export const ConditionOperatori18nAsSymbols = (value: ConditionOperator) => i18n(`symbol.<${value}>`);
